import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TrophiesIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M11.4,13.6v3H9a.6.6,0,0,0,0,1.2h6a.6.6,0,0,0,0-1.2H12.6v-3Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.4,7v4.8a3.6,3.6,0,0,0,7.2,0V7Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.8,8.2V10A1.8,1.8,0,0,1,15,11.8H9A1.81,1.81,0,0,1,7.2,10V8.2h9.6m0-1.2H7.2A1.2,1.2,0,0,0,6,8.2V10a3,3,0,0,0,3,3h6a3,3,0,0,0,3-3V8.2A1.2,1.2,0,0,0,16.8,7Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4.7,13.3v1.5H3.5a.3.3,0,0,0,0,.6h3a.3.3,0,0,0,0-.6H5.3V13.3Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M6.51,13.37a1.74,1.74,0,0,1-1.21.8l-.3,0-.3,0A1.78,1.78,0,0,1,3.3,13a1.61,1.61,0,0,1-.1-.58V10H5v.5a.34.34,0,0,0,0,.1,3.3,3.3,0,0,0,.56,1.8,3.44,3.44,0,0,0,.94,1Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M5.57,12.4H3.5a.73.73,0,0,1-.3-.06.89.89,0,0,1-.6-.84v-.9H5a.34.34,0,0,1,0-.1V10H2.6a.6.6,0,0,0-.6.6v.9A1.48,1.48,0,0,0,3.3,13a.65.65,0,0,0,.2,0H6.06A3.14,3.14,0,0,1,5.57,12.4Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18.7,13.3v1.5H17.5a.3.3,0,0,0,0,.6h3a.3.3,0,0,0,0-.6H19.3V13.3Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M20.8,10v2.4a1.61,1.61,0,0,1-.1.58,1.78,1.78,0,0,1-1.4,1.19l-.3,0-.3,0a1.74,1.74,0,0,1-1.21-.8,3.44,3.44,0,0,0,.94-1A3.3,3.3,0,0,0,19,10.6a.34.34,0,0,0,0-.1V10Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M21.4,10H19v.5a.34.34,0,0,1,0,.1H21.4v.9a.89.89,0,0,1-.6.84.73.73,0,0,1-.3.06H18.43a3.14,3.14,0,0,1-.49.6H20.5a.65.65,0,0,0,.2,0A1.48,1.48,0,0,0,22,11.5v-.9A.6.6,0,0,0,21.4,10Z"
  })]
}), 'TrophiesIcon');